import { Link } from "react-router-dom";

export default function Header() {
  return (
    <header className="w-full border-b bg-white">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">

        {/* LOGO */}
        <a href="https://gymplix.com/" className="flex items-center">
          <img
            src="https://gymplix.com/wp-content/uploads/2026/02/Creative-brains-logoV01.webp"
            alt="GymPlix logo"
className="h-[70px] w-auto object-contain"      

          />
        </a>

        {/* ACTIONS */}
        <div className="flex items-center gap-4">
          <Link
            to="/login"
            className="text-gray-600 hover:text-gray-900 transition"
          >
            Login
          </Link>

          <Link
            to="/register"
            className="px-4 py-2 rounded-md bg-gray-900 text-white hover:bg-gray-800 transition"
          >
            Create account
          </Link>
        </div>

      </div>
    </header>
  );
}
